import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const TackOffert = lazy(() => import("@/pages/info/TackOffert"));

export const Route = createFileRoute("/tack-offert")({
  head: () =>
    seoHead("/tack-offert", {
      description:
        "Vi har tagit emot din offertförfrågan och återkommer inom kort.",
      // Tacksidan nås bara efter ett formulär – den ska inte indexeras.
      noindex: true,
    }),
  component: () => <TackOffert />,
});
